import _taggedTemplateLiteral from "/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import React from 'react';
import { Drawer as Drawer$1 } from '@mui/material';
import { styled } from '@mui/material/styles';
import MUIDrawer from '@mui/material/Drawer';
const isTopBottom = anchor => anchor === "bottom" || anchor === "top";
const isLeftRight = anchor => anchor === "right" || anchor === "left";
const DrawerWrapper = styled(MUIDrawer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .MuiDrawer-paper {\n        width: ", ";\n        height: ", ";\n        max-width: ", ";\n    }\n"])), _ref => {
  let {
    anchor
  } = _ref;
  return isLeftRight(anchor) ? "calc(100% - 2.75rem)" : "100%";
}, _ref2 => {
  let {
    anchor
  } = _ref2;
  return isTopBottom(anchor) ? "calc(100% - 2.75rem)" : "100%";
}, _ref3 => {
  let {
    anchor
  } = _ref3;
  return isLeftRight(anchor) ? "30rem" : "none";
});
const Wrapper = styled("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    background-color: #f7f7f7;\n    width: 100%;\n    height: 2.688rem;\n    border-bottom: 1px solid #eeeeee;\n    padding: 0.8rem 1rem;\n"])));
const CloseIcon = styled("img")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 0.75rem;\n    width: 0.75rem;\n    cursor: pointer;\n"])));
const Title = styled("span")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #000000;\n"])));
const Header = _ref4 => {
  let {
    closeImageSource,
    closeImageAltText,
    dataGaV1,
    dataGaV2,
    testId,
    onClose,
    title,
    showCloseIcon
  } = _ref4;
  const showHeader = title || showCloseIcon;
  const handleOnClick = e => {
    onClose(e, "backdropClick");
  };
  if (!showHeader) return null;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-testid": "".concat(testId, "-header")
  }, title && /*#__PURE__*/React.createElement(Title, {
    "data-testid": "".concat(testId, "-title")
  }, title), showCloseIcon && (/*#__PURE__*/React.createElement(CloseIcon, {
    src: closeImageSource || "/static-content/icons/shared/cross.svg",
    onClick: handleOnClick,
    alt: closeImageAltText,
    "data-ga-v1": dataGaV1,
    "data-ga-v2": dataGaV2,
    "data-testid": "".concat(testId, "-close-icon"),
    role: "button"
  })));
};
const Drawer = _ref5 => {
  let {
    testId = "drawer-container",
    anchor,
    open,
    onClose,
    ModalProps,
    CustomPaperProps = undefined,
    closeImageSource = undefined,
    closeImageAltText = undefined,
    showCloseIcon = true,
    title = undefined,
    dataGaV1 = null,
    dataGaV2 = null,
    children
  } = _ref5;
  const DynamicDrawerComponent = CustomPaperProps ? Drawer$1 : DrawerWrapper;
  return /*#__PURE__*/React.createElement(DynamicDrawerComponent, {
    anchor: anchor,
    open: open,
    onClose: onClose,
    ModalProps: ModalProps,
    "data-testid": testId,
    className: "drawer",
    PaperProps: CustomPaperProps
  }, /*#__PURE__*/React.createElement(Header, {
    title: title,
    closeImageSource: closeImageSource,
    closeImageAltText: closeImageAltText,
    dataGaV1: dataGaV1,
    dataGaV2: dataGaV2,
    showCloseIcon: showCloseIcon,
    testId: testId,
    onClose: onClose
  }), children);
};
export { Drawer };